/**
 * @file ViewInvoicesLink.tsx
 * @brief "View invoices" beside the Billing title (DES 21-10-2026): a company
 *        admin goes to the company's Invoices page, a personal user to their
 *        own Invoices tab. A company member has none (their billing is the
 *        company's).
 *
 * @author DES
 * @date 22-10-2026
 */

import { Receipt } from "lucide-react";
import { Link } from "react-router-dom";
import { billingPath } from "@/features/my-billing/billingPaths";

export function ViewInvoicesLink({ audience }: { audience: "company_admin" | "personal" }) {
  return (
    <Link
      to={audience === "company_admin" ? "/company/invoices" : billingPath("invoices")}
      className="inline-flex shrink-0 items-center gap-1.5 rounded-md text-sm font-medium text-brand outline-none hover:underline focus-visible:ring-2 focus-visible:ring-brand/50"
    >
      <Receipt className="h-4 w-4" />
      View invoices
    </Link>
  );
}
